<div class="home-section-wrapper">
    <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
      <mat-drawer role="navigation" class="fixed" #leftnav [opened]="leftSideNav">
          <uni-left-sidenav-collapsed [showSidenav]="true" [showDiscoverSection]="true">
          </uni-left-sidenav-collapsed>
      </mat-drawer>
  
      <mat-drawer-content>
        <div class="fixed top-0" fxLayout="row" *ngIf="!mobileView" style="filter: drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 50px);">
          <uni-left-sidenav-collapsed [showSidenav]="tabletView" [showDiscoverSection]="!tabletView">
          </uni-left-sidenav-collapsed>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
</div>

<main class="main-section">
    <router-outlet></router-outlet>
</main>